<template>
  <div
    class="button noUserSelect"
    :class="{
      'bm-pressed' : pressed,
      'bm-showTooltip' : hovering
    }"
    @mousedown="press"
    @touchstart="press"
    @touchend="release"
    @mouseup="release"
    @mouseleave="hover(false)"
    @mouseenter="hover(true)"
  >
    <div class="button-tooltip" v-if="tooltip">{{tooltip}}</div>
    <icon-com
      v-if="iconName"
      :name="iconName"
      :size="iconSize"
      :color="iconColor"
      :circleColor="iconCircleColor"
    ></icon-com>
    <div class="button-text" v-if="text">{{text}}</div>
  </div>
</template>

<script>
export default {
  props: ['iconName', 'iconSize', 'iconColor', 'iconCircleColor', 'text', 'tooltip'],
  data () {
    return {
      pressed: false,
      hovering: false
    }
  },
  methods: {
    press () {
      this.pressed = true
    },
    release () {
      this.pressed = false
    },
    hover (hover) {
      this.hovering = hover

      if (!hover) {
        this.release()
      }
    }
  }
}
</script>

<style lang="sass">
@import './../sass/core.sass'

+block('button')
  background-color: #3E66F6
  height: 40px
  border-radius: 40px
  color: #FFF
  padding: 0 22px 0 15px
  cursor: pointer
  display: flex
  justify-content: center
  align-items: center
  transition: .3s
  line-height: 40px
  white-space: nowrap

  +blockModifier('showTooltip')
    z-index: 10

  +blockModifier('pressed')
    transform: scale(.96)

  +blockModifier('noIcon')
    padding: 0 15px

  +blockModifier('onlyIcon')
    padding: 0
    width: 40px

  +blockModifier('hidden')
    opacity: 0
    pointer-events: none
    transform: scale(.6)

  +blockModifier('confirm')
    background-color: #00CA9D

  +blockModifier('loading')
    opacity: .8
    pointer-events: none
    background-color: #D8D8D8

  +blockModifier('cancel')
    background-color: #CCC

  +blockModifier('ghost')
    background-color: transparent
    color: #D8D8D8

  +blockModifier('disabled')
    pointer-events: none
    opacity: .4

  +element('text')
    margin-left: 8px

  +element('tooltip')
    position: absolute
    background-color: #FFF
    padding: 0 10px
    height: 22px
    line-height: 22px
    font-size: 12px
    border-radius: 30px
    white-space: nowrap
    box-shadow: inset 0 0 0 1px rgba(0,0,0,.1), 0 2px 4px rgba(0,0,0,.05)
    color: #666
    pointer-events: none
    top: -23px
    transform: translateY(-5px) scale(.8) translateZ(0)
    transform-origin: 50% 100%
    transition: .3s
    opacity: 0

    +blockModifier('showTooltip')
      transform: translateY(-5px) scale(1) translateZ(0)
      opacity: 1

</style>



// WEBPACK FOOTER //
// src/globalComponents/Button.vue